<template>
    <div>
        <div
            v-click-outside="hideNav"
            class="menu-button d-flex flex-column"
            :class="getButtonStyling()"
            @click="navClick"
        >
            <span  class="menu-item d-flex align-items-center">
                <span class="menu-link">
                    {{ label }}
                    <component :is="ChevronForward" v-if="menu" class="icon align-text-top"></component>
                </span>
            </span>

            <ul v-if="menu && show" class="menu-dropdown">
                <li
                    v-for="(menuItem, index) in menu"
                    :key="index"
                    class="d-flex align-items-center menu-dropdown-item text-start"
                    :class="{[`hide-last-${menu.length - index}`]: !!(menuItem as any)?.nodot}"
                    @click="menuItemClicked(menuItem)">
                    <span class="menu-dropdown-link">
                        {{ (menuItem as any)?.label }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import { ref } from 'vue';
import ChevronForward from '@/assets/icons/chevron-forward.svg';

export default {
    props: {
        label: {
            type: String,
        },
        logo: {
            type: String,
        },
        menu: {
            type: Array,
        },
        menuType: {
            type: String,
            default: 'small',
        },
        styling: {
            type: String,
        },
        design: {
            type: String,
        },
    },
    setup(props: any, context: any) {
        const style = ref(props.styling);
        const dropDownType = ref(props.menuType);
        const show = ref(false);

        function menuItemClicked(menuItem: any) {
            context.emit('menuItemClicked', menuItem);
        }

        function getButtonStyling() {
            const styleObj: any = {};
            if (style.value) {
                styleObj.red = true;
            }

            if (dropDownType.value === 'small') {
                styleObj.relative = true;
            }

            if (props.design) {
                styleObj[props.design] = true;
            }

            if (show.value) {
                styleObj.hidden = true;
            }

            return styleObj;
        }

        function navClick() {
            show.value = !show.value;
            context.emit('navClick');
        }

        function hideNav() {
            show.value = false;
            context.emit('hideNav');
        }

        return {
            navClick,
            hideNav,
            show,
            menuItemClicked,
            getButtonStyling,
            ChevronForward,
        };
    },
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables";

div {
    display: inline-block;
    height: 100%;
    width: 100%;

    .menu-button {
        margin: 0 10px;

        .menu-item {
            font-weight: 500;
            font-family: "DINPro", sans-serif;
            font-stretch: semi-condensed;
            font-size: 18px;
            text-transform: uppercase;
            height: 30px;

            &:hover {
                cursor: pointer;

                .menu-link {
                    border-bottom: 1px solid $kwast-red;
                }
            }

            .icon {
                width: 1rem;
            }

            &.hidden {
                transform: translateX(-500%);
            }

            .menu-link {
                line-height: 29px;
                margin-right: 8px;
                border-bottom: 1px solid transparent;
            }
        }
    }

    .menu-dropdown {
        padding: 11px 0;
        width: 86%;
        height: 100%;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow-y: scroll;
        overflow-x: hidden;

        li {
            padding: 0.4375rem 2rem;
            max-width: 250px;
            flex-grow: 1;
            font-weight: 500;
            font-family: "DINPro", sans-serif;
            font-stretch: semi-condensed;
            &::before {
                content: '';
                height: 0.3125rem;
                width: 0.3125rem;
                background: $black;
                border-radius: 50%;
                margin-right: 0.875rem;
            }
            &.hide-last-1 {
                padding: 11px 2rem 11px 0;
                &::before{
                    background: transparent;
                }
            }
            &.hide-last-2 {
                padding: 11px 2rem 11px 0;
                &::before{
                    background: transparent;
                }
            }
            &.hide-last-3 {
                padding: 11px 2rem 11px 0;
                &::before{
                    background: transparent;
                }
            }
            &.hide-last-4 {
                padding: 11px 2rem 11px 0;
                &::before{
                    background: transparent;
                }
            }
            &.hide-last-5 {
                padding: 11px 2rem 11px 0;
                &::before{
                    background: transparent;
                }
            }
        }

        .menu-dropdown-item {
            cursor: pointer;
            white-space: nowrap;

            &:hover {
                .menu-dropdown-link {
                    border-bottom: 1px solid $kwast-red;
                }
            }

            .menu-dropdown-link {
                font-size: 1rem;
                flex-grow: 1;
                border-bottom: 1px solid transparent;
            }
        }
    }
}
</style>
